export default "__VITE_ASSET__0d1c168d__"